export default "__VITE_ASSET__a747a941__"